/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/templates/qaTemplateLibrary.ts
 * FILE_ID: QA-TEMPLATES-LIBRARY-001
 * PURPOSE: Load published templates, then their details, once for every picker.
 */
import type { QaApi } from '../../../qa/qaApi'
import type { QaTemplateDetail, QaTemplateSummary } from '../../../qa/qaTemplateTypes'

export async function loadQaTemplateLibrary(
  api: Pick<QaApi, 'listTemplates' | 'getTemplate'>,
  onTemplates?: (rows: QaTemplateSummary[]) => void,
  jobId?: number,
) {
  const templates = await api.listTemplates(jobId)
  onTemplates?.(templates)
  return { templates, detailsById: {} as Record<string, QaTemplateDetail> }
}
